<template>
    <!-- 确定类弹窗封装
         @author liuguisheng
         @date 2019-10-28
    -->
    <div class="confirm-dialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="384px">
            <div class="main-wrap">
                <i :class="icon"></i>
                <span>{{content}}</span>
            </div>
            <div class="footer">
                <slot></slot>
            </div>            
        </el-dialog>
    </div>
</template>
<script>
    export default {
        props: {
            // 控制弹层开关
            value: {
                type: Boolean,
                default: false
            },
            // 标题
            title: {
                type: String,
                default: '标题'
            },
            // 图标
            icon: {
                type: String,
                default: ''
            },
            // 内容
            content: {
                type: String,
                default: ''
            }
        },
        computed: {
            // 弹层开关计算
            dialogVisible: {
                get () { 
                    return this.value; 
                },
                set(newValue) { 
                    this.$emit('input', newValue); 
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/base_package/ConfirmDialog.vue